import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  description: {
    id: 'embeds.components.embedError.message',
    defaultMessage: 'Something went wrong and we could not load this page.',
  },
});
